import PrevWarehouseSelectBanner from './components/PrevWarehouseSelectBanner/PrevWarehouseSelectBanner';
import ProviderInformation from './components/ProviderInformation/ProviderInformation';
import SkuProducts from './components/SkuProducts/SkuProducts';
import './SelectProducts.scss';

const SelectProducts = () => {
  return (
    <div className="selectProductsContainer">
      <PrevWarehouseSelectBanner />
      <ProviderInformation />
      <SkuProducts />
    </div>
  );
};

export default SelectProducts;
